import { useState } from "react";
import type { Me } from "../api.js";
import { useI18n } from "../i18n.js";

const NEW = "__new__";

/** Shown in the header when the person belongs to more than one account (or wants another one). */
export function AccountSwitcher({ me, onSwitch, onCreate }: { me: Me; onSwitch: (accountId: string) => void; onCreate: (name: string) => Promise<void> }) {
  const { t } = useI18n();
  const [naming, setNaming] = useState(false);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  return (
    <div className="switcher">
      <label className="sr-only" htmlFor="account-switcher">
        {t("switcher.label")}
      </label>
      <select
        id="account-switcher"
        value={me.activeAccountId ?? ""}
        onChange={(e) => {
          if (e.target.value === NEW) setNaming(true);
          else onSwitch(e.target.value);
        }}
      >
        {me.accounts.map((a) => (
          <option key={a.id} value={a.id}>
            {a.name}
          </option>
        ))}
        <option value={NEW}>{t("switcher.new")}</option>
      </select>
      {naming && (
        <form
          className="row"
          onSubmit={(e) => {
            e.preventDefault();
            setBusy(true);
            void onCreate(name.trim()).finally(() => {
              setBusy(false);
              setNaming(false);
              setName("");
            });
          }}
        >
          <label className="sr-only" htmlFor="new-account-name">
            {t("switcher.newName")}
          </label>
          <input id="new-account-name" value={name} onChange={(e) => setName(e.target.value)} placeholder={t("switcher.newName")} maxLength={100} autoFocus />
          <button className="btn secondary small" type="submit" disabled={busy || !name.trim()}>
            {t("common.save")}
          </button>
          <button className="btn ghost small" type="button" onClick={() => setNaming(false)}>
            {t("common.cancel")}
          </button>
        </form>
      )}
    </div>
  );
}
